import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-manage-adhoc-popup',
  templateUrl: './manage-adhoc-popup.component.html',
  styleUrls: ['./manage-adhoc-popup.component.scss']
})
export class ManageAdhocPopupComponent implements OnInit {
  title: any;
  form: FormGroup
  yesmesg = false;
  nomesg = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ManageAdhocPopupComponent>,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.title = this.data.title
    this.form = this.formBuilder.group({
      productClassification: [],
      isont: [],
    })
  }
  save() {
    if(this.form.value.productClassification){
    let value = this.form.value.productClassification
    this.dialogRef.close(value);
}
  }
  click() {
    let value = this.form.value.isont
    if (value == "1") {
      this.yesmesg = true;
      this.nomesg = false;
    }
    else {
      this.yesmesg = false;
      this.nomesg = true;
    }
  }
  simsave() {
    if (this.form.value.isont) {

      let value = this.form.value.isont
      this.dialogRef.close(value);
    }
  }

}
